<template>
  <div id="content" class="myAccount">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="confirmDelete($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <addLicence :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewLicence($event)" :minLicence="minLicence" :currentLicence="currentLicence" formName="Please enter the new number of licences" ></addLicence>
    <TransfertAccount :dialogVisible='dialogTransfert' :userManaged="account_managed" @close="closeTransfert()" @newValueIsProposed="transfertOwnerShip($event)" formName="Transfer an account" ></TransfertAccount>
    <ConfirmModal :dialogVisible='showConfirmDialogGrantt' @close="closeConfirmDialogGrantt()" @confirmed="granttAccess($event)" message="Are you sure ? Once full access granted to full acess, you can't come back to restrict acces. For a specific project access please invite the user to collaborate to it." ></ConfirmModal>

    <AddAccompagnantModal :dialogVisible='dialogAccompagnant' :userManaged="accompagne" @close="closeAccompagnant()" @newValueIsProposed="setAccompagnant($event)" formName="Choisir l'accompagnant" ></AddAccompagnantModal>

    <PhoneModal :dialogVisible='dialogPhone' @close="dialogPhone=false" @newValueIsProposed="setNewPhone($event)" formName="Edit phone number" :projectName="selectedValue.phone" ></PhoneModal>
    <ConfigAffinity :dialogVisible='dialogAffinity'  @close="closeModalAffinity()" @newValueIsProposed="setNewAffinityConfig($event)"  :userToConfig="candidateForLicence" formName="Configure Affinity access" ></ConfigAffinity>

    <ExpirationModal :dialogVisible='dialogExpiration' @close="closeExpirationModal()" @newValueIsProposed="setNewExpiration($event)"  :currentExpiration="currentExpiration" formName="Please enter the new licence's expiration date" ></ExpirationModal>

    <div class="container">
      <div class="myAccountContent">
        <div class="row">
          <h1 class="title">Manage users account</h1>
          <v-expansion-panels class="mb-6">

      <v-expansion-panel
         v-for="(user, u) in users" :key="u"
      >
        <v-expansion-panel-title expand-icon="mdi-menu-down">
          {{user.entreprise}} - Account owner : {{user.firstname}} {{user.lastname}}
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="cols2">


          <div class="oneCol">


          <div class="label_user">
            <span class="info_name">Account owner </span>
            <span class="info_value"> {{user.firstname}} {{user.lastname}} - {{user.email}}</span>
          </div>
          <div class="label_user">
            <span class="info_name">Last connection </span>
            <span class="info_value"><span v-if="user.lastLoginDate">{{this.formattedDate(user.lastLoginDate)}}</span>
          <span v-else>N.C.</span></span>
          </div>
          <div class="label_user">
            <span class="info_name">Phone </span>
            <span class="info_value"  v-if="user.phone"> {{user.phone}}</span> <v-btn variant="outlined" size="x-small" icon="mdi-pencil" @click="editPhone(user)"></v-btn>
          </div>
          <div class="label_user" v-if="user.role == 'Responsable'">
            <span class="info_name">Licence </span>
            <span class="info_value">
              <span v-if="user.managedAccount">{{user.managedAccount.length + 1}} / {{user.licence}}</span>
              <span v-else>1 / {{user.licence}}</span>
            </span>
          </div>
          <div class="label_user" v-if="user.rights">
            <span class="info_name">Rights </span>
            <span class="info_value">{{formatedRights(user.rights)}}</span>
          </div>
          <div class="label_user" v-if="user.licence_start || user.licence_end">
            <span class="info_name">Licence validity</span>
            <span class="info_value">
              <span v-if="user.licence_start">  &nbsp; From {{formatedDate(user.licence_start)}}</span>
              &nbsp;
              <span v-if="user.licence_end">To {{formatedDate(user.licence_end)}} </span>
            </span>
          </div>
          <div class="label_user" >
            <span class="info_name">Active </span>
            <span class="info_value">
              <v-badge v-if="user.isValid" color="info" content="Yes" inline></v-badge>
              <v-badge v-else color="warning" content="No" inline></v-badge>
            </span>
          </div>
                </div>

                <div class="oneCol col2">
                  <div class="myaccountlogo">
                    <img  v-if="user.logo"  :src="this.apiUrl+'/get_image/'+user.logo.$oid+'?token='+$store.state.innotoken"   alt="" class="myaccountlogoImage">
                    <div class="fallBackLogoProfile" v-else style="">
            YOUR LOGO
                    </div>
                    <div class="changeImageLogo" v-if=" user._id ">
                       <button type="button" name="button" @click='triggerFileInput(user._id)'>
                           <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
                       </button>
                       <input type="file" class="logoUp_" :ref="'logoUp_' + user._id"
        :name="'logoUp_' + user._id"
        :id="'logoUp_' + user._id" @change="selectLogo($event,user._id.$oid,user)" accept="image/*"/>
                      </div>
                      <div class="row uploadProceedBanner" v-if="uploadProceedLogo">
                        <div class="col-12 text-center uploadProcess">
                            <span class="progressText">Upload in progress. Please wait a moment.</span>
                          <v-progress-linear
                            v-model="progress[user._id.$oid]"
                            color="blue-grey"
                            height="25"
                          >
                        </v-progress-linear>

                        </div>

                      </div>
                  </div>
                </div>
                          </div>
          <br/>
          <table class="table mt20" v-if="user.managedAccount.length > 0">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Last connection</th>
                <th>Phone</th>
                <th>Rights</th>
                <th>Active</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(subu, du) in user.managedAccount" :key="du">
                <td>{{subu.email}}
                  <button class="showActivationLinkButton" v-if= "!subu.isValid && subu.activator" @click="toggle(du)">
                    {{ activeIndex == du ? 'Hide link' : 'Show activation link' }}
                  </button>
                  <div v-if="activeIndex == du" class="item-details">
                  <span class="TheActivationLink">https://partnerplus.innopearl.ch/register_confirm/{{subu.activator.$oid}}</span>
                  </div>
                </td>
                <td>{{subu.firstname}} {{subu.lastname}}</td>
                <td><span v-if="subu.lastLoginDate">{{this.formattedDate(subu.lastLoginDate)}}</span></td>
                <td>{{subu.phone}}  <v-btn variant="outlined" size="x-small" icon="mdi-pencil" @click="editPhone(subu)"></v-btn></td>
                <td>{{formatedRights(subu.rights)}}</td>
                <td>
                  <v-badge v-if="subu.isValid" color="info" content="Yes" inline></v-badge>
                  <v-badge v-else color="warning" content="No" inline></v-badge>
                </td>

                <td>
                  <div style="display:flex;flex-wrap:wrap;gap:20px;justify-content:center;">
                    <button v-if="subu.role != 'Responsable'" class="btn btn-danger mlrtb10" type="button" @click="deleteAccount(subu._id.$oid)" name="button">Remove</button>
                    <button v-if="subu.rights == 'OwnProjectOnly'" class="btn  btn-primary mlrtb10" type="button" @click="granttRightsModal(subu._id.$oid)" name="button">Give full access</button>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>
           <div class="mt20"  v-if="user.accompagnepar.length > 0">
            <strong>Support team</strong>

          <table class="table ">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>

                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(subu, du) in user.accompagnepar" :key="du">
                <td>{{subu.email}}

                </td>
                <td>{{subu.firstname}} {{subu.lastname}}</td>

                <td>
                  <button class="btn btn-danger mlrtb10" type="button" @click="deleteAccompagnant(subu._id.$oid,user._id.$oid)" name="button">Remove</button>

                </td>
              </tr>
            </tbody>

          </table>
                </div>
          <a :href="'/register?createdFor='+user._id.$oid" v-if="user.role == 'Responsable'" class="btn btn-primary mlrtb10">Add a user</a>
          <button v-if="user.role == 'Responsable'" @click="openTransfert(user)" class="btn btn-primary mlrtb10" type="button" name="button">Transfer ownership</button>
          <button v-if="user.role == 'Responsable'" @click="openModalAffinity(user)" class="btn btn-primary mlrtb10" type="button" name="button">Affinity access</button>
          <button v-if="user.role == 'Responsable'" @click="openExpirationModal(user)" class="btn btn-primary mlrtb10" type="button" name="button">Licence expiration</button>
          <button v-if="user.role == 'Responsable'" @click="openModal(user)" class="btn btn-primary mlrtb10" type="button" name="button">Licences allocation</button>
          <button v-if="user.role == 'Responsable'" @click="openAccompagnant(user)" class="btn btn-primary mlrtb10" type="button" name="button">Add supporter</button>

        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>


        <!-- <table class="table mt20" v-if="users.length > 0">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Active</th>
              <th>Licence(s)</th>
              <th>Responsable</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, u) in users" :key="u">
              <td>{{user.username}}</td>
              <td>{{user.email}}</td>
              <td>{{user.firstname}} {{user.lastname}}</td>
              <td>{{user.role}} {{user.rights}}</td>
              <td>
                <v-badge v-if="user.isValid" color="info" content="Yes" inline></v-badge>
                <v-badge v-else color="warning" content="No" inline></v-badge>
              </td>
              <td>
                <span v-if="user.role == 'Responsable'">
                  <span v-if="user.account_managed">{{user.account_managed.length + 1}} / {{user.licence}}</span>
                  <span v-else>1 / {{user.licence}}</span>
                </span>
                <span v-else>N.C.</span>

              </td>
              <td>
                <span v-if="user.responsable">{{user.responsable.firstname}} {{user.responsable.lastname}}</span>
              </td>
              <td>
                <button v-if="user.role == 'Responsable'" @click="openTransfert(user)" class="btn btn-primary mlrtb10" type="button" name="button">Transfert ownership</button>

                <button v-if="user.role == 'Responsable'" @click="openModal(user)" class="btn btn-primary mlrtb10" type="button" name="button">Licences allocation</button>
                <button v-if="user.role != 'Responsable'" class="btn btn-danger mlrtb10" type="button" @click="deleteAccount(user._id.$oid)" name="button">Remove</button></td>
            </tr>
          </tbody>

        </table> -->


      </div>
    </div>
          </div>
</div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
 import api from '@/tools/api';
  import addLicence from '@/components/modals/addLicence.vue'
// //import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import _ from 'lodash';
 import ConfirmModal from '@/components/modals/ConfirmModal.vue'
  import TransfertAccount from '@/components/modals/transfertAccount.vue'
  import PhoneModal from '@/components/modals/projectNameModal.vue'
  import ConfigAffinity from '@/components/modals/ConfigAffinity.vue'
  import ExpirationModal from '@/components/modals/ExpirationModal.vue'
  import AddAccompagnantModal from '@/components/modals/AddAccompagnantModal.vue'


export default {
  components: {
    ConfirmModal,
    addLicence,
    TransfertAccount,
    ConfigAffinity,
    PhoneModal,
    ExpirationModal,
    AddAccompagnantModal
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      activeIndex:null,
      apiUrl: process.env.VUE_APP_API_URL,
      seeAllStep: true,
      dialog:false,
      dialogTransfert:false,
      transfertFrom : null,
      account_managed: [],
      showConfirmDialogGrantt: false,
dialogExpiration:false,
candidateForExpiration:null,
      minLicence: 0,
      pageInfo: {
        mainTitle : "Manager users",
        subTitle : "Manage users of the platform",
      },
      users: [],
      showConfirmDialog: false,
      asked_for_delete: null,
      candidateForLicence : null,
      selectedValue:{phone:''},
dialogPhone:false,
userLogo:null,
chunksLogo: [],
uploaded: 0,
uploadProceed: false,
progress :0,
uploadProceedLogo:false,
dialogAccompagnant:false,
accompagne:[],
accompagnant_for:null,
    }
  },
  methods:{
    setNewAffinityConfig(e){
      console.log(e);
      this.closeModalAffinity();
      api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
        this.users = r.data;
        console.log("data",r);
            console.log("all_useres",r);
      }).catch( (e) => console.log(e));
    },
    formattedDate(d) {
     // Extract the numeric timestamp
     const timestampValue = parseInt(d.$date.$numberLong, 10);

     // Convert to a Date object
     const date = new Date(timestampValue);

     // Format the date as 'YYYY-MM-DD HH:mm:ss'
     return new Intl.DateTimeFormat('fr-FR', {
       year: 'numeric',
       month: '2-digit',
       day: '2-digit',
     }).format(date);
   },
    selectLogo(event,userid,user) {
      this.uploaded = 0;
        this.file = event.target.files.item(0);
        console.log(userid);
        this.userLogo = user;
        this.createChunksLogo(userid);
        this.uploadProceedLogo = true;
        // console.log(this.chunks);
        // this.upload();
    },
    triggerFileInput(userId) {
     this.$refs['logoUp_' + userId][0].focus();
     this.$refs['logoUp_' + userId][0].click();
   },
    logoChange(val){
      if(val){
        this.userLogo.logo = val;
        this.userLogo = null;
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    uploadLogo() {
          this.axios(this.configLogo).then((r) => {
            console.log(r);
            this.chunksLogo.shift();
            if(r.data)if(r.data)this.addedFile = r.data;
          }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
      },
    createChunksLogo() {
          let size = 8192, chunks = Math.ceil(this.file.size / size);

          for (let i = 0; i < chunks; i++) {
              this.chunksLogo.push(this.file.slice(
                  i * size, Math.min(i * size + size, this.file.size), this.file.type
              ));
          }
      },
    editPhone(user){
        this.selectedValue = user;
        this.dialogPhone = true;
    },
    setNewPhone(v){
      if(v){
        console.log(this.selectedValue);
        api.post(process.env.VUE_APP_API_URL+"/restrict/change_phone",
        {
          mongoid : this.selectedValue._id.$oid,
          newphone : v,
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Phone updated ");
         this.selectedValue.phone = v;
         this.dialogPhone =false;

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    openAccompagnant(user){
      api.get(process.env.VUE_APP_API_URL+"/restrict/allvaliduser").then( (r) => {
        this.accompagne = r.data;
        console.log("data",r);
            console.log("all_useres",r);
            this.accompagnant_for = user._id;
            this.dialogAccompagnant = true;
      }).catch( (e) => console.log(e));

    },
    closeAccompagnant(){
      this.accompagne = [];
      this.accompagnant_for = null;
      this.dialogAccompagnant = false;
    },
    setAccompagnant(v){
      console.log(v);

      api.post(process.env.VUE_APP_API_URL+"/restrict/add_accompagnant",
      {
        accompagne : this.accompagnant_for.$oid,
        accompagnant : v.accompagnant.$oid,
      },{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        this.closeAccompagnant();
        api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
          this.users = r.data;
          console.log("data",r);
              console.log("all_useres",r);
        }).catch( (e) => console.log(e));
      });

    },
    deleteAccompagnant(accompagnant,accompagne){
      api.post(process.env.VUE_APP_API_URL+"/restrict/remove_accompagnant",
      {
        accompagne : accompagne,
        accompagnant : accompagnant,
      },{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        this.closeAccompagnant();
        api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
          this.users = r.data;
          console.log("data",r);
              console.log("all_useres",r);
        }).catch( (e) => console.log(e));
      });
    },
    openTransfert(user){
      console.log(user);
      this.account_managed = user.managedAccount;
      this.transfertFrom = user._id;
      this.dialogTransfert = true;
    },
    formatedDate(r){
      console.log(r.date);
      const date = new Date(r.date);
      if (!isNaN(date.getTime())) {
        // Then specify how you want your dates to be formatted
        return new Intl.DateTimeFormat('fr',{
        dateStyle: "short",
      }).format(date);
      }else{
        return r;
      }
    },
    closeTransfert(){
      this.dialogTransfert = false;
      this.account_managed = [];
      this.transfertFrom = null;
    },
    granttRightsModal(u){
      this.showConfirmDialogGrantt = true;
      this.granttfor = u;
    },
    closeConfirmDialogGrantt(){
      this.showConfirmDialogGrantt = false;
      this.granttfor = null;
    },
    granttAccess(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/granttAccess/"+this.granttfor,{},{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
            this.users = r.data;
            console.log(r);
          }).catch( (e) => console.log(e));
        toast.success("Account rights successfully grantted to full access !");
        this.showConfirmDialogGrantt = false;
        });
      }
    },
    transfertOwnerShip(v){
      console.log(v);
      if(v){
        var pos = {
          newowner : v.newowner,
          oldowner : this.transfertFrom,
        }
        api.post(process.env.VUE_APP_API_URL+"/restrict/transfertOwnerShip",pos,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
            this.users = r.data;
            console.log(r);
          }).catch( (e) => console.log(e));
        toast.success("Account ownership successfully tranfered !");
        this.dialogTransfert = false;
        });
      }
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    deleteAccount(v){
      this.showConfirmDialog = true;
      this.asked_for_delete = v;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
      this.asked_for_delete = null;
    },
    openModalAffinity(candidate){
      this.candidateForLicence = candidate;
      this.dialogAffinity = true;
    },
    closeModalAffinity(){
      this.candidateForLicence = null;

      this.dialogAffinity = false;
    },
    openModal(candidate){
      this.candidateForLicence = candidate;
      this.currentLicence = candidate.licence;
      this.minLicence = (candidate.account_managed) ? candidate.account_managed.length + 1 : 0;
      this.dialog = true;
    },
    openExpirationModal(candidate){
      this.candidateForExpiration = candidate;
      this.currentExpiration = candidate.licence_end?.date;
      this.dialogExpiration = true;
    },
    closeExpirationModal(){
      this.dialogExpiration = false;
    },
    setNewExpiration(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/uplicenceexpiration",
        {
          licence_end : v,
          user : this.candidateForExpiration,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Licence expiration date updated");
        this.dialogExpiration = false;
        api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
          this.users = r.data;
          console.log("all_useres",r);
        }).catch( (e) => console.log(e));

      }).catch( () => {
          this.candidateForLicence = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      }
    },
    closeModal(){
      this.candidateForLicence = null;

      this.dialog = false;
    },
    setNewLicence(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/uplicence",
        {
          licence : parseInt(v),
          user : this.candidateForLicence,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Number of licence updated");
        this.dialog = false;
        api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
          this.users = r.data;
          console.log("all_useres",r);
        }).catch( (e) => console.log(e));

      }).catch( () => {
          this.candidateForLicence = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      }
    },
    formatedRights(r){
      if(r == "FullProjectAccess"){
        return "Access to all projects";
      }
      else if(r == "OwnProjectOnly"){
        return "Access to your own projects only";
      }
      else{
        return "N.D.";
      }
    },
    confirmDelete(v){
      console.log(v);
      console.log(this.asked_for_delete);
      this.showConfirmDialog = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeaccount",
          {
              toremoved: this.asked_for_delete,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
            toast.success("User successfully delete from your account.")
            api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
              this.users = r.data;
              console.log(r);
                  console.log("all_useres",r);
            }).catch( (e) => console.log(e));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.asked_for_delete = null;
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/all_users_responsable_and_souscompte_and_accompagnant").then( (r) => {
       this.users = r.data;
       console.log("data",r);
           console.log("all_useres",r);
     }).catch( (e) => console.log(e));
   },
 watch: {

      chunksLogo: {
        handler(val) {
          if (val.length > 0) {
                 this.uploadLogo();
          }
          else{
            this.uploadProceedLogo = false;
            this.logoChange(this.addedFile);

          }
        },
        deep: true
      },

 },
 computed:{

   formDataLogo() {
       let formData = new FormData;
       console.log(this.userLogo);
       formData.set('imageTargetDBField', "logo");
       formData.set('is_last', this.chunksLogo.length === 1);
       formData.set('file', this.chunksLogo[0], `${this.file.name}.part`);
       formData.set('file_extension_original', this.file.name.split('.').pop());
       formData.set('account', this.userLogo._id.$oid);
       formData.set('fileType', "logo");
       return formData;
   },
   configLogo() {
     var formData = new FormData;

      formData.set('imageTargetDBField', "logo");
      formData.set('is_last', this.chunksLogo.length === 1);
      formData.set('file', this.chunksLogo[0], `${this.file.name}.part`);
      formData.set('file_extension_original', this.file.name.split('.').pop());
      formData.set('account', this.userLogo._id.$oid);
      formData.set('fileType', "logo");

       return {
           method: 'POST',
           data: formData,
           url: this.apiUrl+'/upload_logo_account',
         //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

           headers: {
               'Content-Type': 'application/octet-stream'
           },
           onUploadProgress: event => {
               this.uploaded += event.loaded;
           }
       };
   }
 },
 // watch(search, (newValue, oldValue) => {
 //   console.log(oldValue);
 //   console.log(newValue);
 //   // fires on nested property mutations
 //   // Note: `newValue` will be equal to `oldValue` here
 //   // because they both point to the same object!
 // },{deep: true})
}
</script>
<style scoped >
.myAccount{
  padding-top:50px;
  padding-bottom: 50px;
}
.myAccountContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-bottom: 50px;

}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
text-align:center;
}
.mt50{
  margin-top:50px;
}

.mlrtb10{
  margin:10px;
}


.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}

.myAccountContent{
  position:relative;
  padding-top:80px;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}

.disconnect{
  position: absolute;
top: 10px;
right: 10px;
padding: 5px 20px;
color: #3783C5;
border: none;
border-bottom: 1px solid #3783C5;
border-radius: 0;
font-size: 16px;
font-weight: bold;
text-decoration: none;
}

.infoVersion{
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-size: 10px;
}

.v-window{
  border: 1px solid #3783C5;
  margin-bottom:50px;
}
.v-tabs{
      background: #115AA4 !important;

}
.v-tab--selected{
  background: #3783C5 !important;
}
.v-tab__slider{
  display:none;
}

.btn-primary{
    background: #3783C5 !important;
    border:none !important;
}

.label_user .info_name{
font-size: 12px;
line-height: 15px;
color: #B38D2F;
text-transform: uppercase;
font-weight: 500;
}
.label_user  .info_value{
    font-size:16px;
    line-height: 22px;

}


.myaccountlogo{
  width:250px;
  height:100px;
  display:flex;
  justify-content: center;
  align-items: center;
  margin-bottom:20px;
  position:relative;
  margin: auto;
    margin-bottom: auto;
  margin-bottom: 20px;
}
.myaccountlogoImage{
  width:250px;
  height:100px;
  object-fit: contain;
  margin: auto;
}


.fallBackLogoProfile{
  width:250px;
  height:100px;
  background:#EFEFEF;text-align:center;text-align: center;
display: flex;
justify-content: center;
align-content: center;
align-items: center;
}


.changeImageLogo{
  position:absolute;
  top:5px;
  right:5px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 5px;

}


.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}

.logoUp_{
  display: none;
}

.cols2{
  display:flex;
  flex-wrap: wrap;
}

.cols2 > div:nth-child(1){
  flex:1;
}
.cols2 .col2{
  justify-content: center;
  align-items: center;
  width:300px;
}

@media screen and (max-width:990px){
  .cols2{
    flex-direction: column;
  }
}

.showActivationLinkButton{
  border:1px solid #3783C5;
  padding:2px 5px;
  display: block;
  font-size:12px;
  color: #3783C5;
  border-radius:20px;
}

.TheActivationLink{
  font-weight: bold;
  color: #3783C5;
  text-decoration: underline;
}

</style>
